import React, { useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { Grid, Typography } from "@material-ui/core";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import Service from "./RegionService";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import DefaultChip from "../../componentes/chip/DefaultChip";

const columnsCity = (t) => [
    { field: "idCidade", visible: false },
    {
        field: "nmCidade",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="city" name="map" />;
        }, flex: 0.5,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.nmCidade}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "ddd",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="ddd" />;
        }, flex: 0.5,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.ddd}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "cdIBGE",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="cdIBGE" />;
        }, flex: 0.5
    },
    {
        field: "status",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        width: 150,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

const RegionCity = () => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    function reducer(state, action) {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case 'clear':
                return initialCityRegistrationState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return state
        }
    }

    const initialCityRegistrationState = {
        idCidade: 0,
        idEstado: 0,
        idPais: 0,
        nmCidade: "",
        ddd: "",
        cdIBGE: "",
        status: 1,
        cityRows: [],
        idUser: userId,
        alertMessage: "",
        success: false,
        error: false
    };

    const [city, dispatch] = useReducer(reducer, initialCityRegistrationState)
    const { idCidade, idEstado, idPais, nmCidade, ddd, cdIBGE, status, cityRows, alertMessage, success, error } = city


    const handleChange = ({ target: { name, value } }) => {
        dispatch({
            type: 'update',
            data: { [name]: value }
        })
    }

    const canSave = () => nmCidade;

    const handleSearchRegionCity = () => {
        const { cityRows, alertMessage, success, error, ...data } = city
        Service
            .getCity(data)
            .then((response) => {
                dispatch({
                    type: 'update',
                    data: { cityRows: response.data }
                })
            })
            .catch((e) => { });
    };

    const handleClearRegionCity = () => {
        dispatch({ type: 'clear' })
    };

    const saveRegionCity = () => {
        const { cityRows, alertMessage, success, error, ...data } = city
        if (canSave()) {
            if (idCidade === 0) {
                Service
                    .createCity(data)
                    .then((response) => {
                        if (response.status === 200 && response.data.idCidade > 0) {
                            dispatch({
                                type: 'success',
                                data: { alertMessage: t("success"), error: false, success: true }
                            })
                            handleSearchRegionCity();
                        }
                    })
                    .catch((e) => { });
            } else {
                Service
                    .updateCity(data)
                    .then((response) => {
                        if (response.status === 200 && response.data.idCidade > 0) {
                            dispatch({
                                type: 'success',
                                data: { alertMessage: t("success"), error: false, success: true }
                            })
                            handleSearchRegionCity();
                        }
                    })
                    .catch((e) => { });
            }
        }
        else {
            dispatch({
                type: 'update',
                data: { alertMessage: t("checkFields"), error: true, success: false }
            })
        }
    };

    const selectedCityChanged = (data) => {
        dispatch({
            type: 'update',
            data: { idCidade: idCidade, ...data, }
        })

    };

    return (

        <DefaultScreenAccordion
            title={t("city")}
            isRegister
            fields={
                <>
                    <GridItemContainer>
                        <CustomAlert
                            message={alertMessage}
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <GridInputRow>
                            <Grid item xs={3}>
                                <DefaultAutocomplete
                                    name={"idPais"}
                                    onChange={handleChange}
                                    placeholder={t("country")}
                                    label={t("country")}
                                    useApi
                                    endpoint='GetCountryAutocomplete'
                                    value={idPais}
                                    defaultSize
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <DefaultAutocomplete
                                    name={"idEstado"}
                                    onChange={handleChange}
                                    placeholder={t("state")}
                                    label={t("state")}
                                    useApi
                                    endpoint='GetStateAutocomplete'
                                    contextKey={idPais}
                                    value={idEstado}
                                    defaultSize
                                />
                            </Grid>
                            <Grid item md={3}>
                                <InputField
                                    iconLabelSwitch={<IconLabelSwitch fontSize="small" name="map" labelName="nmCidade" />}
                                    name="nmCidade"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={nmCidade}
                                    length={50}
                                    translationString={"city"}
                                />
                            </Grid>
                            <Grid item md={3}>
                                <InputField
                                    name="ddd"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={ddd}
                                    length={50}
                                    translationString={"ddd"}
                                />
                            </Grid>
                            <Grid item md={3}>
                                <InputField
                                    name="cdIBGE"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={cdIBGE}
                                    length={50}
                                    translationString={"cdIBGE"}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <DefaultAutocomplete
                                    name={"status"}
                                    onChange={handleChange}
                                    value={status}
                                    label={t("status")}
                                    defaultSize
                                    items={[
                                        { id: 0, name: t("canceled"), status: 1 },
                                        { id: 1, name: t("active"), status: 1 },
                                        { id: 2, name: t("all"), status: 1 },
                                    ]}
                                    error={error && status === 2}
                                    placeholder={t("status")}
                                />
                            </Grid>
                        </GridInputRow>

                        <SearchClearSaveRow
                            onClickSearch={handleSearchRegionCity}
                            onClickSave={saveRegionCity}
                            onClickClear={handleClearRegionCity}
                        />
                    </GridItemContainer>

                    {cityRows.length > 0 ? (
                        <DefaultDatagrid
                            dataSource={cityRows}
                            columns={columnsCity(t)}
                            allowPaging={true}
                            cellSelected={(selected) => {
                                selectedCityChanged(selected.data);
                            }}
                        />
                    ) : null}
                </>
            } />

    );
};

export default RegionCity;